import { render, staticRenderFns } from "./DashboardSettingsDrawer.vue?vue&type=template&id=a7c17810&scoped=true"
import script from "./DashboardSettingsDrawer.vue?vue&type=script&lang=js"
export * from "./DashboardSettingsDrawer.vue?vue&type=script&lang=js"
import style0 from "./DashboardSettingsDrawer.vue?vue&type=style&index=0&id=a7c17810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c17810",
  null
  
)

export default component.exports